import {post} from "../modules/ajax";
import EmblaCarousel from "embla-carousel";

let ajaxOuterMenu = null;
export function getOuterMenu(id)
{
    if (ajaxOuterMenu) ajaxOuterMenu.abort();

    return new Promise(resolve => {
        ajaxOuterMenu = post(
            '/ajax/website/outer-menu/get-outer-menu',
            {id: id},
            function(data) {
                resolve(data.html);
            },
            function() {
                resolve(null);
            }
        )
    });
}

export function getOuterMenus()
{
    return new Promise(resolve => {
        post(
            '/ajax/website/outer-menu/get-outer-menus',
            {},
            function(data) {
                resolve(data.html);
            },
            function() {
                resolve(null);
            }
        )
    });
}

export function showLoader()
{
    let container = document.querySelector('#outer-menu-container');

    container.innerHTML += '<div class="outer-menu-loader h-300px d-flex justify-content-center align-items-center"><div class="spinner-border"></div></div>';
}

export function hideLoader()
{
    let container = document.querySelector('#outer-menu-container');
    let loader = container.querySelector('.outer-menu-loader');
    if (loader) loader.remove();
}

export function initHeaderOuterMenuSlider()
{
    let slider = document.querySelector('#slider-header-outer-menu');
    if (slider) {
        let emblaPrevButton = slider.closest('.embla-container').querySelector('.embla-prev-button');
        let emblaNextButton = slider.closest('.embla-container').querySelector('.embla-next-button');
        let emblaCarousel = EmblaCarousel(slider, {slidesToScroll: 'auto'});

        emblaCarousel.on('init', function() {
            if (emblaCarousel.canScrollNext()) emblaNextButton.classList.remove('d-none');
        });

        emblaPrevButton.addEventListener('click', emblaCarousel.scrollPrev, false);
        emblaNextButton.addEventListener('click', emblaCarousel.scrollNext, false);

        emblaCarousel.on('select', function() {
            if (emblaCarousel.canScrollPrev() && emblaPrevButton.classList.contains('d-none')) emblaPrevButton.classList.remove('d-none');
            if (!emblaCarousel.canScrollPrev() && !emblaPrevButton.classList.contains('d-none')) emblaPrevButton.classList.add('d-none');
            if (emblaCarousel.canScrollNext() && emblaNextButton.classList.contains('d-none')) emblaNextButton.classList.remove('d-none');
            if (!emblaCarousel.canScrollNext() && !emblaNextButton.classList.contains('d-none')) emblaNextButton.classList.add('d-none');
        });
    }
}